module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Luetisburg-fcc7f3aefe8395f6692a3e0df58aa7e5.png";